/**
 * コミュニティ機能のポーリング間隔定数
 * 各機能で使用するポーリング間隔をミリ秒単位で定義
 */

/**
 * チャットメッセージの変更をポーリングする間隔（5秒）
 * 用途: チャットの編集、削除、リアクション、スレッド数の更新を検知
 */
export const CHAT_CHANGES_POLLING_INTERVAL = 5000;

/**
 * チャンネルリストを更新する間隔（60秒）
 * 用途: サイドバーのチャンネルリスト（未読数など）の定期更新
 */
export const CHANNEL_LIST_POLLING_INTERVAL = 60000;

/**
 * チャンネルデータの再検証間隔（60秒）
 * 用途: チャンネル詳細データ（権限、設定など）の定期的な再検証
 */
export const CHANNEL_REVALIDATION_INTERVAL = 60000;

/**
 * スレッドデータのポーリング間隔（5秒）
 * 用途: スレッドビューの親チャットと返信の定期更新
 */
export const THREAD_POLLING_INTERVAL = 5000;

/**
 * メッセージ投稿/編集後の追加ポーリング遅延（3秒）
 * 用途: リンクプレビューの非同期生成に対応するため、投稿直後に1度だけ早めにポーリングを実行する
 */
export const POST_SEND_POLL_DELAY = 3000;
